import { createFileRoute } from "@tanstack/react-router";
import {
  SpringsLandingPage,
  buildSpringsLandingHead,
} from "@/components/SpringsLandingPage";
import { getSpringsLandingConfig } from "@/lib/springsLandingData";

const CONFIG = getSpringsLandingConfig("colorado-springs-seo-falcon");

export const Route = createFileRoute("/colorado-springs-seo-falcon")({
  head: () => buildSpringsLandingHead(CONFIG),
  component: () => <SpringsLandingPage config={CONFIG} />,
});
